import { axios } from '~/clients';
import { SEBS_API } from '~/constants/endpoints';
import { SebastianQuestions } from '~/contracts/vdp';

type QuestionsRequest = {
  correlationId: string;
  kbbVehicleId: number;
  userId?: string;
  vehicleId: number;
  year: number;
  make: string;
  model: string;
  trim: string;
  page: string;
};

export default function fetchSebastianQuestions(
  request: QuestionsRequest,
  controller: AbortController
) {
  const {
    kbbVehicleId,
    correlationId,
    userId,
    vehicleId,
    year,
    make,
    model,
    trim,
    page
  } = request;
  const req = {
    correlation_id: correlationId,
    kbb_vehicle_id: kbbVehicleId,
    user_id: userId,
    vehicle_id: vehicleId,
    year,
    make,
    model,
    trim,
    page
  };

  return axios
    .post<SebastianQuestions>(SEBS_API, req, {
      signal: controller.signal,
      timeout: 8000
    })
    .then(res => {
      return res.data;
    });
}
